<template>
  <div class="oc">
    <table class="table oc__table">
      <thead>
        <tr>
          <th>訂單編號</th>
          <th>訂單建立日期</th>
          <th>總金額</th>
          <th>結帳時間</th>
          <th>出貨狀態</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in memberOrders"
        :key="index">
          <td>{{item.id}}</td>
          <td>{{convert_time(item.createTime)}}</td>
          <td>{{item.sum}}</td>
          <td>
            <span v-if="!item.payment.ifPaid">
              未結帳
            </span>
            <span class="d-flex flex-column" v-if="item.payment.ifPaid">
              <span>
                結帳時間:
              </span>
              <span>
                {{item.payment.info.time}}
              </span>
            </span>
          </td>
          <td>
            <span v-if="!item.sending.ifSent">
              未出貨
            </span>
            <span v-if="item.sending.ifSent">
              <span>
                {{convert_time(item.sending.info.sentTime)}}
              </span>
              <span>
                已出貨
              </span>
            </span>
          </td>
          <td>
            <a href="#" class="myBtn myBtn--primary"
              @click="go_page(`/front/checkout_payment/${item.id}`)">
              查看詳細資料 / 結帳
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['member', 'orders'],
  computed: {
    memberOrders() {
      let orderArr = [];
      const memberId = this.member.id;
      const filteredOrders = this.orders.filter((item) => item.memberId === memberId);
      orderArr = JSON.parse(JSON.stringify(filteredOrders));
      return orderArr;
    },
  },
  data() {
    return {
      collapse: true,
    };
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
    convert_time(timeNum) {
      const theDate = new Date(timeNum);
      const year = theDate.getFullYear();
      const month = theDate.getMonth() + 1;
      const day = theDate.getDate();
      const twoDigits = (num) => (num > 9 ? '' : '0') + num;
      const timeStr = `${year}-${twoDigits(month)}-${twoDigits(day)}`;
      return timeStr;
    },
  },
};
</script>
